import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Dropdown, Flex, Row, Space } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate, formatDateTime } from "utils/formatter";

const PendingApprovalOvertimeTable = ({
  isModalOpen = false,
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onReturn = () => { },
  onApprove = () => { },
  onApproveAll = () => { },
  onRejectAll = () => { },
  onReject = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onChange = () => { },
  onOpenModal = () => { },
  pageType = ""
}) => {
  const { t, i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;

  const formatTime = (hours, minutes, language) => {
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return language === "en" ? formattedTime : `${formattedTime} น.`;
  };

  const columns = [
    {
      title: <div className="text-table">{t('reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
    },
    {
      title: <div className="text-table">{t('translation.employee.employee')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: !isModalOpen,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.employee?.nameAndSurnameEn}</span> : <span>{record?.employee?.nameAndSurname}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.label.create-date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      render: (_, record) => {
        return record?.createDate ? formatDate(record?.createDate) : "-"
      }
    },
    {
      title: <div className="text-table">{t('leave_type.label.dateOfRequest')}</div>,
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        return record?.startDate ? formatDate(record?.startDate) : "-"
      }
    },
    // {
    //   title: <div className="text-table">{t('end-date')}</div>,
    //   dataIndex: "endDate",
    //   key: "endDate",
    //   render: (_, record) => {
    //     return record?.endDate ? formatDate(record?.endDate) : "-"
    //   }
    // },
    {
      title: <div className="text-table">{t('collect_time.start_time')}</div>,
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: <div className="text-table">{t('collect_time.end_time')}</div>,
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: <div className="text-table">{t('leave_type.label.duration')}</div>,
      dataIndex: "duration",
      key: "duration",
      align: "center",
      render: (_, record) => {
        return i18n.language === 'en' ? record?.totalDurationHour + "H " + record?.totalDurationMinute + "M" : record?.totalDurationHour + " ชม. " + record?.totalDurationMinute + " นาที"
      }
    },
    // {
    //   title: <div className="text-table">{t('description.description')}</div>,
    //   dataIndex: "description",
    //   key: "description",
    // },
    {
      title: <div className="text-table">{t('status.status')}</div>,
      dataIndex: "approveStatus",
      key: "approveStatus",
      align: "center",
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
        // let tagColor = "green";
        // if (record?.approveStatusEn === "Pending") {
        //   tagColor = "blue";
        // } else if (record?.approveStatusEn === "Rejected" || record?.approveStatusEn === "Cancelled") {
        //   tagColor = "red";
        // }
        // return i18n.language === 'en' ? <Tag color={tagColor}>{record?.approveStatusEn}</Tag> : <Tag color={tagColor}>{record?.approveStatus}</Tag>
      },
    },
    // isModalOpen && {
    //   title: <div className="text-table">{t('request_all.approver')}</div>,
    //   dataIndex: "approverBy",
    //   key: "approverBy",
    //   align: "center",
    //   render: (text, record) => {
    //     if (typeof text === 'string') {
    //       const obj = JSON.parse(text);
    //       return obj && obj.name && obj.surname ? `${obj.name} ${obj.surname}` : "-";
    //     }
    //     return '-';
    //   }
    // },
    isModalOpen && {
      title: <div className="text-table">{t('วันที่อนุมัติ')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    !isModalOpen && {
      title: "",
      key: "action",
      align: "center",
      width: "50px",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "2",
                  onClick: () => { onOpenModal(record); },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "3",
                  onClick: () => onApprove({
                    ...record,
                    table: "PendingApprovalOvertimeTable"
                  }),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "4",
                  onClick: () => onReject({
                    ...record,
                    table: "PendingApprovalOvertimeTable"
                  }),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ].filter(Boolean);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Flex vertical gap={16}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              selectionColumnWidth: "45px"
            },
          },
        }}
      >
        <TableAntd
          loading={isLoading}
          style={{ backgroundColor: "white", width: "100%" }}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              t("paginate.description")
                .replace("{min}", range[0])
                .replace("{max}", range[1])
                .replace("{total}", total),
          }}
          dataSource={processedDataSource}
          rowKey={(record) => record.id}
          columns={columns}
          onChange={onChange}
          scroll={{ x: true }}
          rowSelection={pageType === "view" ? rowSelection : undefined}
        />
      </ConfigProvider>

      {hasSelected && pageType === "view" &&
        (<Flex vertical gap={8} style={{ alignItems: "end" }}>
          <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
          <Row style={{ gap: "8px" }}>
            <Button
              type="default"
              style={{ borderRadius: "8px", height: "40px" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onRejectAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >
              {t("request_approval.label.not_approved")}</Button>
            <Button
              type="primary"
              style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onApproveAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >{t("request_approval.label.approve")}</Button>
          </Row>
        </Flex>)}
    </Flex>
  );
};

export default PendingApprovalOvertimeTable;
